export default "__VITE_ASSET__BzYx5FuB__"